import { IA11yNodeInfo, NodeAction, a11yNodePropertyKeys, NodeActionKeys, nodeActions } from "../../../a11y/A11yNode"
import { SFData } from "../../../a11y/sfdata"
import { createActionUtils, IActionData, IActionJavaData, IActionShellData } from "../../../action"
import { a11yNamespace } from "../a11y-namespace"
import { ulid } from "ulid"
import {UI} from "./UI"
const type = `${a11yNamespace}node-execute`

export interface IActionA11yNodeJavaData extends IActionJavaData {
    // sfData?:SFData
    info?:IA11yNodeInfo
    action?:NodeAction
    setText?:string
    selectedProperties:a11yNodePropertyKeys[]
    regexProperties:IA11yNodeRegexProperties
    wait:IA11yNodeWait
}

export interface IA11yNodeRegexProperties{
    text?:string
    contentDescription?:string
    hintText?:string
}
export interface IA11yNodeWait{
    time:number
    interval:number
    invisible:boolean
}

export interface IActionA11yNodeExecute extends IActionData<IActionShellData, IActionA11yNodeJavaData> {
    javaData:IActionA11yNodeJavaData
}
function createDefaultData():IActionA11yNodeExecute{
    return {
        id:ulid(),
        type,
        javaData:{
            selectedProperties:[],
            regexProperties:{},
            wait:{
                time:0,
                interval:0,
                invisible:false
            },
            
            action:nodeActions[NodeActionKeys.click]
        }
    }
}

function init(){

}

export const actionA11yNodeExecuteUtils = createActionUtils(type, init, createDefaultData, UI) 